import { render } from "./ProjectDetailDashboard.vue?vue&type=template&id=1abb3057&scoped=true&ts=true"
import script from "./ProjectDetailDashboard.vue?vue&type=script&lang=ts"
export * from "./ProjectDetailDashboard.vue?vue&type=script&lang=ts"

import "./ProjectDetailDashboard.vue?vue&type=style&index=0&id=1abb3057&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abb3057"]])

export default __exports__